import { createContext, useContext } from 'react';

export interface IdleDetectionContextValue {
  showWarning: boolean;
  timeRemaining: number;
  extendSession: () => Promise<void>;
  logout: () => Promise<void>;
  recordActivity: () => void;
  isLoggingOut: boolean;
}

export const IdleDetectionContext = createContext<IdleDetectionContextValue | null>(null);

export const useIdleDetection = (): IdleDetectionContextValue => {
  const context = useContext(IdleDetectionContext);
  if (!context) {
    throw new Error('useIdleDetection must be used within IdleDetectionProvider');
  }
  return context;
};
